import player from './player'
export default player
